import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../utils/PiePage.component'
import InputField from '../../utils/InputMUI'
import SelectField from '../../utils/SelectMUI'
import MultiSelect from '../../utils/MultiSelectMUI'
import { SaveUpdatePayoutConfig, getCommunityPayoutDetailsBycommunityId } from './DealerActioncreator'

const tagData=[
    {
        code:"CGST",
        name:"CGST",
    },
    {
        code:"SGST",
        name:"SGST",
    },
    {
        code:"IGST",
        name:"IGST",
    },
    {
        code:"VAS Receipt",
        name:"VAS Receipt",
    },
    {
        code:"Loan Transfer",
        name:"Loan Transfer",
    },
]
const modeOfPaymentDate =[
    {
        code:"Cash",
        name:"Cash",
    },
    {
        code:"Bank Transfer",
        name:"Bank Transfer",
    },
   
] 
export default function BasicDetails({ handlePage, handleTabs,communityId, Detaildata }) {
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [ObjectData, setObjectData] = useState({
        ledger: '',
        commission: '',
        commissionLedger: '',
        tds: '',
        tdsLedger: '',
        tag: "",
        modeOfPayment: [],
      

    })


    useEffect(() => {
            if (Detaildata?.rowData?.communityId) {
                setloaderState(true)
                getCommunityPayoutDetailsBycommunityId(Detaildata?.rowData?.communityId, (callback) => {
                    console.log("Detaildata?.communityId", callback)
                    if (callback && callback?.status == 200  && callback?.message == "success") {
                        setObjectData({
                            ledger: callback?.data?.ledger || '',
                            commission: callback?.data?.commission || '',
                            commissionLedger: callback?.data?.commissionLedger || '',
                            tds: callback?.data?.tds || '',
                            tdsLedger: callback?.data?.tdsLedger || '',
                            tag: callback?.data?.tag || "",
                            modeOfPayment: callback?.data?.modeOfPayment || [],
                        })
                    } else {
                        setObjectData({
                            ledger: '',
                            commission: '',
                            commissionLedger: '',
                            tds: '',
                            tdsLedger: '',
                            tag: "",
                            modeOfPayment: [],
                        })
                    }
                    setloaderState(false)
                })
            }
        }, [Detaildata?.rowData])


    const inputChange = (e, type) => {

        let changeObjectData = Object.assign({}, ObjectData)

       
            changeObjectData[type] = e
        

        setObjectData(changeObjectData)

    }


    const saveHandler = (e) => {
        if (e === 'save') {
            setloaderState(true)
            const obj={...ObjectData,communityId:communityId}
            SaveUpdatePayoutConfig(obj,(callback)=>{
                setloaderState(false)
                console.log("call",callback)
                if(Detaildata?.rowData?.communityId){
                    handlePage("", "list")
                }else{
                    handleTabs("breconfig")
                }
            })
        } else if (e === 'close') {
            handlePage("", "list")
        }
    }

    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                <PiePage
                    totalPage={Detaildata?.rowData?.communityId ? 4 :6}
                    currentPage={4}
                    heading={'Add Payout Configuration'}
                />


                <div className='row'>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Ledger"
                            variant="outlined"
                            value={ObjectData.ledger}
                            name="ledger"
                            id="ledger"
                            type="text"
                            onChange={e => inputChange(e, 'ledger')}
                            size="small"
                        // required={true}
                        />
                        {/* {
                            errors?.address &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.address}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Commission (in %)"
                            variant="outlined"
                            value={ObjectData.commission}
                            name="commission"
                            id="commission"
                            type="number"
                            onChange={e => inputChange(e, 'commission')}
                            size="small"

                        />
                        {/* {
                            errors?.area &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.area}</div>
                        } */}


                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Commission Ledger"
                            variant="outlined"
                            value={ObjectData.commissionLedger}
                            name="commissionLedger"
                            id="commissionLedger"
                            type="text"
                            onChange={e => inputChange(e, 'commissionLedger')}
                            size="small"

                        />
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="TDS (in %)"
                            variant="outlined"
                            value={ObjectData.tds}
                            name="tds"
                            id="tds"
                            type="number"
                            onChange={e => inputChange(e, 'tds')}
                            size="small"

                        />
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="TDS Ledger"
                            variant="outlined"
                            value={ObjectData.tdsLedger}
                            name="tdsLedger"
                            id="tdsLedger"
                            type="text"
                            onChange={e => inputChange(e, 'tdsLedger')}
                            size="small"

                        />
                        {/* {
                            errors?.multipleEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.multipleEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                    <SelectField
                            value={ObjectData.tag}
                            label="Tag"
                            onChange={e => inputChange(e, 'tag')}
                            name="tag"
                            data={tagData}
                            size={'small'}

                        />
                        {/* {
                            errors?.multipleEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.multipleEmail}</div>
                        } */}

                    </div>

                </div>

                <div className="row">
                <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                    <MultiSelect
                            value={ObjectData.modeOfPayment}
                            label="Mode Of Payment"
                            onChange={e => inputChange(e, 'modeOfPayment')}
                            name="modeOfPayment"
                            inputData={modeOfPaymentDate}
                            size={'small'}

                        />
                        {/* {
                            errors?.multipleEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.multipleEmail}</div>
                        } */}

                    </div>
                </div>
               


                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save and Continue</button>
                    </div>
                </div>
            </div>
        </>
    )
}
